import {
    action,
    computed, makeAutoObservable, observable, toJS
} from 'mobx';
// import config from '../configs_/config.js';
import { formatCurrency } from '../utils/Currency.js';
// import ArManagerClass from '../utils/AR';
import { isIOS, isMobileDevice } from '../utils/Device';
import { delay, throttle } from '../utils/Events';
import { deepCopy } from '../utils/Object.js';
import { simpleRouter, SimpleRouterClass } from '../utils/Router';
import SketchfabControllerClass from '../utils/SketchfabController';
import { confirm, swalAlert } from '../utils/Swal.js';
import { publicUrl } from '../utils/url.js';
import { CartClass } from './Cart.js';
import { SelectedMaterial } from './SelectedMaterial';
import SaveProject from './SaveProject.js';
import FiltersStore from './FiltersStore.js';
import SelectedSwatchesStore from './SelectedSwatchesStore.js';
import { animate, frame } from 'motion';
import { OPTION_ADDITIONAL_MATTRESS, OPTION_DRAWER_FILL, PUBLIC_URL } from './constants.js';
import { getProduct, BASE_URL, getBasketConfiguration } from '../utils/api.js';
import { isFeatureEnabled } from '../utils/Features.js';
import FabricCollectionModel, { FabricCollectionDataType } from '../models/FabricCollectionModel.js';
import FabricModel from '../models/FabricModel.js';
import { groupBy, uniqueBy } from '../utils/ArrayUtils.js';
import OptionModel from '../models/OptionModel.js';
import StepModel from '../models/StepModel.js';
import ProductModel from './ProductModel.js';
import '../mockups/frontAPI.mockup.js'
import QuizStore from './QuizStore.js';
import { MATTRESS_SIZE_OPTION_ID } from '../models/ProductConfigurationOption.js';
import { act } from 'react';
import { Gtm } from '../utils/Gtm.js';
import { Clarity } from '../utils/Clarity.js';
import { Synerise } from '../utils/Synerise.js';
import { calculateDeliveryDate } from '../utils/DateUtils.js';
import { lang } from '../utils/Lang.js';

const QRCode = require('qrcode')
const BREAKPOINT_XL = 1200;

function sortMultiSelectValues(valueIds, stepOptions) {
    return [...valueIds].sort((a, b) => {
        const aIsOptionModel = stepOptions.some(o => o instanceof OptionModel && o.valueId === a) ? 0 : 1;
        const bIsOptionModel = stepOptions.some(o => o instanceof OptionModel && o.valueId === b) ? 0 : 1;
        return bIsOptionModel - aIsOptionModel;
    });
}


class StoreClass {
    // config = config1
    // sf: SketchfabControllerClass;
    cart: CartClass;
    saveProject: SaveProject;
    quiz: QuizStore;
    fabricFilters: FiltersStore;
    selectedSwatches: SelectedSwatchesStore;
    lang = lang;

    isAccordionOpenByDefault = window.innerWidth > BREAKPOINT_XL;
    isAccordionInteractive = window.innerWidth < BREAKPOINT_XL;

    // router: SimpleRouterClass
    // project: ProjectClass
    // slotsController: SlotsController
    // cart: CartClass
    // ar: ArManagerClass

    @observable config;
    @observable product: ProductModel;
    @computed get productDeliveredIn(){
        // 5-7 dni roboczych
        var daysString = this.product?.deliveryDays;
        if(daysString){
            // print based on daysString format: 5-7 {month}
            return calculateDeliveryDate(daysString, lang.current);
        }
        return null;
    }
    @observable sampleFabricProdcut: ProductModel = null;
    @observable mattress: ProductModel[] = [];
    @observable mattress_toppers: ProductModel[] = [];
    @observable safety_products: ProductModel[] = [];

    @computed get mattressComparision() {
        return this.mattress.filter((m:ProductModel) => {

            const hasSome = store.mattressMatchingSize.some(s => m.hasMatchingVariant(s.optionId, s.valueId))
            return hasSome

        });
    }

    @computed get mattressFullSize() {
        const step = this.getStepByType("radio_dimensions");

        if (this.canUseFullSizeMattress === false) {
            return [];
        }

        if (step) {
            const option = step.options.find(
                (option) => option.valueId === step.value
            );
            if (option) {
                return option.full_materac_size;
            }
        }
        return [];
    }
    @computed get additionalSizeMattress() {
        const step = this.getStepByType("radio_dimensions");


        if (step) {
            const option = step.options.find(
                (option) => option.valueId === step.value
            );
            if (option) {
                return option.additional_materac_size;
            }
        }
        return [];
    }
    @computed get mattresSize() {
        const step = this.getStepByType("radio_dimensions");

        if (step) {
            const option = step.options.find(
                (option) => option.valueId === step.value
            );
            if (option) {
                const { length: l, width: w } = option;
                if (this.mattressAmount === 1) {
                    return `${w}x${l}cm`;
                }
                return `${parseInt(w / 2)}x${l}cm`;
            }
        }
        return [];
    }
    @computed get additionalMattresSize() {
        if(this.additionalSizeMattress.length > 0){
            return String(this.additionalSizeMattress[0].name).replaceAll(' ', '').replace('cmx', 'x');
        }
        return null;
    }
    @computed get mattressHalfSize() {
        const step = this.getStepByType("radio_dimensions");

        if (this.canUseHalfSizeMattress === false) {
            return [];
        }

        if (step) {
            const option = step.options.find(
                (option) => option.valueId === step.value
            );
            if (option) {
                return option.half_materac_size;
            }
        }
        return [];
    }

    /**
     * false if selected frame prevents using full size mattress
     * @returns {boolean}
     */
    @computed get canUseFullSizeMattress() {
        const frameStep = this.getStepByType("select_frame");
        if(frameStep && frameStep.selectedOption){ 
            console.log(`frameStep.selectedOption.cannot_be_full: ${frameStep.selectedOption.cannot_be_full}`);
            console.log(frameStep.selectedOption);
            return frameStep.selectedOption.cannot_be_full === false;
        }
        return true;
    }

    /**
     * false if selected frame prevents using half size mattress
     * @returns {boolean}
     */
    @computed get canUseHalfSizeMattress() {
        const frameStep = this.getStepByType("select_frame");
        if(frameStep && frameStep.selectedOption){ 
            return frameStep.selectedOption.cannot_be_half === false;
        }
        return true;
        
    }
    @computed get hasAnyHalfSizeMattress() {
        return this.mattressHalfSize.length > 0;
    }
    @computed get hasSelectedMattressMatchingFullSize() {
        var amount = this.selectedMattress.filter(m => {
            var hasSome = this.mattressFullSize.some(s => m.hasMatchingVariant(s.optionId, s.valueId))
            return hasSome 
        });
        return amount.length > 0
    }
    @computed get hasSelectedMattressMatchingHalfSize() {
        var amount = this.selectedMattress.filter(m => {
            var hasSome = this.mattressHalfSize.some(s => m.hasMatchingVariant(s.optionId, s.valueId))
            return hasSome 
        });
        return amount.length > 0
    }
    @computed get mattressMatchingSize() {
        if (this.mattressAmount === 1) {
            return this.mattressFullSize;
        }
        return this.mattressHalfSize;
    }
    @observable mattressAmount = 1;
    @action setMattressAmount(amount) {
        this.mattressAmount = amount;

        this.updateMattressAmountIfNeeded();


        Gtm.setStore(this);
        Gtm.push({
            event: "konfigurator_click",
            ecommerce: {
                button_name: "wybór materaca",
                button_typ: "szczegol",
                option: amount === 1 ? "jeden materac" : "dwa materace",
                etap: 6,
                value: this.cart.totalPrice,
                items: [
                    {
                    item_name: "Łóżko Adele",
                    item_id: "30",
                    item_brand: "MyBed",
                    item_category: "Łóżka",
                    item_variant: "informacje o obecnych wybranych wariantach produktu"
                    }
                ]
            }
        })
        Clarity.push("konfigurator_click - szczegol - wybór materaca");
    }

    @observable fabric_features: Array<{
        id: number,
        name: string,
        attributes: Array<any>,
    }> = [];
    @observable fabric_properties: Array<{
        id: number,
        name: string,
        attributes: Array<any>,
    }> = [];
    @observable fabric_collection: FabricCollectionModel[] = [];
    @computed get fabricCollectionFiltered() {
        var list = this.fabric_collection;
        if (this.fabricFilters?.hasFilters) {
            list = list.filter((fc) => {
                const propertiesIds = fc.fabricProperties.map(
                    (fp) => fp.id
                );
                const febricColorsIds = fc.febricColorsIds;
                const characteristics =
                    this.fabricFilters.getFilterValue("characteristics");
                const colors = this.fabricFilters.getFilterValue("colors");

                var matches = true;
                const matchesProperties = characteristics.every((fpId) => propertiesIds.includes(fpId));
                if( characteristics.length > 0 ) {
                    matches = matchesProperties;
                }
                const matchesColors = colors.some((fpId) => febricColorsIds.includes(fpId));
                if(colors.length > 0) {
                    matches = matches && matchesColors;
                }

                return matches;
            });
        }
        list = list.filter(fc => fc.fabrics.length > 0);
        // return list;
        return list.toSorted((a, b) => {
            const sorting = this.fabricFilters.getFilterValue("sorting");
            if(sorting === 'DEFAULT' || !sorting) {
                return a.priority - b.priority;
            }
            if (sorting === "ASC" || !sorting) {
                return a.price - b.price;
            }
            return b.price - a.price;
        });
    }
    // @computed get fabricCollectionSorted() {
    //     return this.fabricCollectionFiltered.toSorted((a, b) => {
    //         const sorting = this.fabricFilters.getFilterValue('sorting');
    //         if(sorting === 'ASC' || !sorting) {
    //             return a.price - b.price;
    //         }
    //         return b.price - a.price;
    //     })
    // }

    @observable pendingRequest = true;
    @observable currentOpenAccordion = 1;
    @observable isMobileDevice = isMobileDevice();
    @observable steps: Map = new observable.map([]);
    @computed get sortedSteps(): StepModel[] {
        return Array.from(this.steps.values()).sort(
            (a, b) => a.order - b.order
        );
    }
    @computed get sortedStepsFlat(): StepModel[] {
        var arr = [];
        this.sortedSteps.forEach((step) => {
            arr.push(step);
            step.components?.forEach((component) => {
                arr.push(component);
            });
        });
        return arr;
    }
    @computed get ownedSteps(): StepModel[] {
        return this.sortedStepsFlat.filter((step) => !!step.owner);
    }


    @computed get groups() {
        var groups = [];
        this.sortedStepsFlat.forEach((step) => {
            if (
                step.stepGroup &&
                !groups.find((g) => g.id === step.stepGroup.id)
            ) {
                groups.push({
                    id: step.stepGroup.id,
                    name: step.stepGroup.name,
                    steps: this.sortedStepsFlat.filter(
                        (s) => s.stepGroup?.id === step.stepGroup.id
                    ),
                });
            }
        });
        return groups;
    }

    @observable isOpen = false;
    @observable hasUnsavedChanges = false;
    // MYB-121: true when the configurator was opened from the basket for editing
    @observable isBasketEditMode = false;
    @computed get isBasketUpdateMode() {
        return isFeatureEnabled() && this.isBasketEditMode;
    }
    @action closeConfigurator() {
        this.scrollTo(0, { animate: false });
        // if (this.hasUnsavedChanges) {
            Synerise.setStore(this);
            Synerise.push('configurator.exit_without_save', {
                ...Synerise.getConfiguratorParams()
            });
        
        Gtm.setStore(this);
        Gtm.push({
            event: "konfigurator_click",
            ecommerce: {
                button_name: "zamknij bez zapisywania",
                value: Gtm.getPrice(),
                items: [
                    {
                        item_name: Gtm.getProductName(),
                        item_id: Gtm.getProductId(),
                        item_brand: "MyBed",
                        item_category: "Łóżka",
                        item_variant: Gtm.getVariantStr(),
                    }
                ]
            }
        });
        Clarity.push("konfigurator_click - zamknij bez zapisywania");
        
        this.hideModal();
        this.saveProject.cleanUrl();
        this.isOpen = false;
        this.isOnExitOpen = false;
        this.hasUnsavedChanges = false;
        this.fabricFilters.resetFilters();
        this.isBasketEditMode = false;
        this.cleanBasketConfigUrl();
    }

    // MYB-121: removes the basketConfig url param without touching user id/hash
    @action cleanBasketConfigUrl() {
        this.cart.basketConfigId = null;
        const u = new URL(window.location.href);
        if (u.searchParams.has('basketConfig')) {
            u.searchParams.delete('basketConfig');
            window.history.replaceState(window.history.state || {}, '', u);
        }
    }

    @action hideLoader() {
        this.pendingRequest = false;
    }
    @action showLoader() {
        this.pendingRequest = true;
    }

    // dimensions table
    @observable isOpenDimensions = false;
    @observable dimensionsOptions = {showControls: true};
    @observable dimensionOptionId = null;
    @computed get dimensionOptions() {
        return this.getOptionsByOptionId(this.dimensionOptionId);
    }
    @computed get selectedDimension() {
        const step = this.getStepByType("radio_dimensions");
        if (step) {
            const option = step.options.find(
                (option) => option.valueId === step.value
            );
            if (option) {
                return option;
            }
        }
        return null;
    }
    @computed get previewDimension() {
        const step = this.getStepByType("radio_dimensions");
        if (step) {
            const option = step.options.find(
                (option) => option.valueId === step.previewValue
            );
            if (option) {
                return option;
            }
        }
        return null;
    }
    @action openDimensions(id, { showControls = true } = {}) {
        if (id !== undefined) {
            this.dimensionOptionId = id;
        }
        this.dimensionsOptions = {showControls};
        this.isOpenDimensions = true;



        Gtm.setStore(this);
        Gtm.push({
            event: "konfigurator_click",
            ecommerce: {
                button_name: "pełne wymiary",
                button_typ: "szczegol",
                option: "",
                etap: 1,
                value: this.cart.totalPrice,
                items: [
                    {
                        item_name: this.product.name,
                        item_id: Gtm.getProductId(),
                        item_brand: "MyBed",
                        item_category: "Łóżka",
                        item_variant: Gtm.getVariantStr(),
                    }
                ]
            }
        });
        Clarity.push("konfigurator_click - szczegol - pełne wymiary");
    }
    @action closeDimensions() {
        this.isOpenDimensions = false;
    }

    // bedhead
    @observable isOpenBedheadDimensions = false;
    @observable bedheadOptionId = null;
    @computed get bedheadOptions() {
        return this.getOptionsByOptionId(this.bedheadOptionId);
    }
    @action openBedheadDimensions(id) {
        this.bedheadOptionId = id;
        this.isOpenBedheadDimensions = true;
    }
    @action closeBedheadDimensions() {
        this.isOpenBedheadDimensions = false;
    }

    // selected dimension
    @observable selectedDimesionId = 0;
    @action updateSelectedDimesion(dimesionId) {
        this.selectedDimesionId = dimesionId;
    }

    // selected height
    @observable selectedHeightId = 0;
    @observable selectedPreviewHeightId = 0;
    @action updateSelectedHeight(heightId) {
        this.selectedHeightId = heightId;
    }
    @action updateSelectedPreviewHeight(heightId) {
        this.selectedPreviewHeightId = heightId;
    }

    // selected height
    @observable selectedHeadBoardId = 1;
    @action selectHeadboard({ optionId }) {
        this.selectedHeadBoardId = optionId;
    }

    // comparision
    @observable isOpenComparision = false;
    @action openComparision() {
        this.isOpenComparision = true;


        Gtm.push({
            event: "konfigurator_click",
            ecommerce: {
                button_name: 'porównaj modele',
                value: Gtm.getPrice(),
                items: [
                    {
                        item_name: Gtm.getProductName(),
                        item_id: Gtm.getProductId(),
                        item_brand: "MyBed",
                        item_category: "Łóżka",
                        item_variant: Gtm.getVariantStr(),
                    }
                ]
            }
        });
        Clarity.push("konfigurator_click - porównaj modele");
    }
    @action closeComparision() {
        this.isOpenComparision = false;
    }

    // mattress single/double
    @observable isMattressTypeOpen = false;
    @action openMattressType() {
        this.isMattressTypeOpen = true;
    }
    @action closeMattressType() {
        this.isMattressTypeOpen = false;
    }

    // hardness chosing popup
    @observable isHardnessOpen = false;
    @action openHardnessPopup() {
        this.isHardnessOpen = true;
    }
    @action closeHardnessPopup() {
        this.isHardnessOpen = false;
    }

    // saving popup
    @observable isOpenSavingPopup = false;
    @action openSavingPopup() {
        this.isOpenSavingPopup = true;
        this.saveProject.goToDefault();
        this.saveProject.saveProjectData();

        Gtm.setStore(this);
        Gtm.push({
            event: "add_to_wishlist",
            ecommerce: {
                konfigurator: "tak",
                items: [
                    {
                    item_name: Gtm.getProductName(),
                    item_id: Gtm.getProductId(),
                    item_brand: "MyBed",
                    item_category: "Łóżka",
                    item_variant: Gtm.getVariantStr(),
                    }
                ]
            }
        })
        Clarity.push("add_to_wishlist");
    }
    @action closeSavingPopup() {
        this.isOpenSavingPopup = false;
    }

    // summary popup
    @observable isOpenSummaryPopup = false;
    @action closeSummaryPopup() {
        this.isOpenSummaryPopup = false;
    }
    @action openSummaryPopup() {
        this.isOpenSummaryPopup = true;
    }

    // swatches colors
    @observable isSwatchesOpen = false;
    @action openSwatches() {
        this.isSwatchesOpen = true;
    }
    @action closeSwatches = () => {
        this.isSwatchesOpen = false;
    };

    // CartSummaryModal
    @observable isCartSummaryPopupOpen = false;

    @action openCartSummaryPopup() {
        this.isCartSummaryPopupOpen = true;
    }
    @action closeCartSummaryPopup = () => {
        this.isCartSummaryPopupOpen = false;
    };

    // Frames details modal
    @observable isFrameDescriptionOpen = false;
    @observable isFrameDescriptionData = null;
    @action openFrameDescription(data) {
        this.isFrameDescriptionData = data;
        this.isFrameDescriptionOpen = true;
    }
    @action closeFrameDescription = () => {
        this.isFrameDescriptionOpen = false;
        this.isFrameDescriptionData = null;
    };

    // Selected items
    @observable selectedSwatchesCategoryId = null;
    @observable isSwatchesCategoryOpen = false;
    @action closeSwatchesCategory = () => {
        this.isSwatchesCategoryOpen = false;
    };
    @action openSwatchesCategory = ({ id }) => {
        this.selectedSwatches.openCategory(id);
        this.selectedSwatchesCategoryId = id;
        this.isSwatchesCategoryOpen = true;
    };

    // Fabric category
    @observable selectedFabricId = null;
    @observable fabrics: FabricModel[] = [];
    @computed get selectedFabric() {
        // return this.fabrics.find((f) => f.id === this.selectedFabricId);
        return this.fabrics.find((f) => f.valueId === this.selectedFabricId);
    }
    @computed get fabricsColorGroups() {
        if(!this.fabrics) return [];
        let unique = uniqueBy(this.fabrics, (el) => el.colorGroup?.id, [0]);
        return unique.map((f) => f.colorGroup);
    }
    @action selectFabric(id) {
        this.selectedFabricId = id;

        Gtm.setStore(this);
        Gtm.push({
            event: "konfigurator_click",
            ecommerce: {
                button_name: "rodzaj tkaniny",
                button_typ: "szczegol",
                option: Gtm.getSelectedFabricStr(),
                etap: 2,
                value: this.cart.totalPrice,
                items: [
                    {
                        item_name: this.product.name,
                        item_id: Gtm.getProductId(),
                        item_brand: "MyBed",
                        item_category: "Łóżka",
                        item_variant: Gtm.getVariantStr(),
                    }
                ]
            }
        });
        Clarity.push("konfigurator_click - szczegol - rodzaj tkaniny");
    }

    @observable selectedCategoryId = 1;
    @observable isFabricCategoryOpen = false;
    @computed get selectedCategory() {
        return this.fabric_collection.find(
            (fc) => fc.id === this.selectedCategoryId
        );
    }
    @action openFabricCategory = (id) => {
        this.selectedCategoryId = id;
        this.isFabricCategoryOpen = true;

        Gtm.setStore(this);
        Gtm.push({
            event: "konfigurator_click",
            ecommerce: {
                button_name: "rodzaj tkaniny",
                button_typ: "sekcja",
                option: String(this.selectedCategory?.name).toLowerCase(),
                etap: 2,
                value: this.cart.totalPrice,
                items: [
                    {
                        item_name: this.product.name,
                        item_id: Gtm.getProductId(),
                        item_brand: "MyBed",
                        item_category: "Łóżka",
                        item_variant: Gtm.getVariantStr(),
                    }
                ]
            }
        });
        Clarity.push("konfigurator_click - sekcja - rodzaj tkaniny");
    };
    @action closeFabricCategory = (e,{tracking = true} = {}) => {
        this.isFabricCategoryOpen = false;

        if (tracking) {

            Gtm.setStore(this);
            Gtm.push({
                event: "konfigurator_click",
                ecommerce: {
                    button_name: "wróć do rodzaju tkaniny",
                    button_typ: "szczegol",
                    option: Gtm.getSelectedFabricStr(),
                    etap: 2,
                    value: this.cart.totalPrice,
                    items: [
                        {
                        item_name: Gtm.getProductName(),
                        item_id: Gtm.getProductId(),
                        item_brand: "MyBed",
                        item_category: "Łóżka",
                        item_variant: Gtm.getVariantStr(),
                        }
                    ]
                }
            })
            Clarity.push("konfigurator_click - szczegol - wróć do rodzaju tkaniny");
        }


    };

    @observable isMattressDetailsOpen = false;
    @action closeMattressDetailsPopup() {
        this.isMattressDetailsOpen = false;
    }
    @action openMattressDetailsPopup() {
        this.isMattressDetailsOpen = true;
    }

    // Technical card
    @observable isTechnicalCardOpen = false;
    @action closeTechnicalCardPopup() {
        this.isTechnicalCardOpen = false;
    }
    @action openTechnicalCardPopup() {
        this.isTechnicalCardOpen = true;
    }

    // Video Modal
    @observable videoPopupUrl = false;
    @observable isVideoPopupOpen = false;
    @action closeVideoPopup() {
        this.isVideoPopupOpen = false;
        this.videoPopupUrl = null;
    }
    @action openVideoPopup({videoUrl = null} = {}) {
        this.videoPopupUrl = videoUrl;
        this.isVideoPopupOpen = true;
    }

    // on exit alert
    @observable isOnExitOpen = false;
    @action closeOnExit() {
        this.isOnExitOpen = false;
    }
    @action openOnExit() {
        this.isOnExitOpen = true;

        
        Gtm.push({
            event: "konfigurator_click",
            ecommerce: {
                button_name: 'wyjdź z konfiguratora',
                value: Gtm.getPrice(),
                items: [
                    {
                        item_name: Gtm.getProductName(),
                        item_id: Gtm.getProductId(),
                        item_brand: "MyBed",
                        item_category: "Łóżka",
                        item_variant: Gtm.getVariantStr(),
                    }
                ]
            }
        });
        Clarity.push("konfigurator_click - wyjdź z konfiguratora");
    }

    // Frame
    @observable selectedFrameId = 1;
    @action selectFrame = ({ id }) => {
        this.selectedFrameId = id;
    };

    // Additional Mattress
    @observable selectedAdditionalMattressId = 0;
    @observable selectedAdditionalMattress: ProductModel[] = [];
    @action selectAdditionalMattress = ({ valueId }) => {
        if (this.selectedAdditionalMattressId === valueId) {
            return;
        }
        this.selectedAdditionalMattressId = valueId;
        

        if (valueId === 0) {
            this.selectedAdditionalMattress = [];
            return;
        }

        var newMattress = this.mattress
            .find((m) => m.valueId === this.selectedAdditionalMattressId)
            ?.clone();
        // copy options to m
        const oldMattress = this.selectedAdditionalMattress.at(0);

        if (newMattress) {
            newMattress.options_configuration.forEach((option) => {
                const size = this.additionalSizeMattress.find(
                    (o) => o.optionId === option.id
                );
                if (size) {
                    option.value = size.valueId;
                    return;
                }
                if (oldMattress) {
                    const oldValue = oldMattress.options_configuration.find(
                        (o) => o.id === option.id
                    )?.value;
                    option.value = oldValue || option.options.at(0)?.valueId;
                }
            });
            // replace at index or add if not exist
            this.selectedAdditionalMattress = [newMattress];
        }
       
        // cut to amout
        // if (this.selectedAdditionalMattress.length > amount) {
        //     this.selectedAdditionalMattress.length = amount;
        // }

    };

    // Mattress
    @observable selectedMattressId = 0;
    @observable selectedMattress: ProductModel[] = [];
    @action updateMattressAmountIfNeeded() {
        if (this.selectedMattressId === 0) {
            this.selectedMattress = [];
            return;
        }
        // clone if needed
        if (this.selectedMattress.length === 0) {
            // if no mattress selected
            var m = this.mattress
                .find((m) => m.id === this.selectedMattressId)
                ?.clone();
            if (m) {
                // if found
                this.selectedMattress.push(m);
            }
        }
        if (this.selectedMattress.length > this.mattressAmount) {
            // if more than needed
            this.selectedMattress = this.selectedMattress.slice(
                0,
                this.mattressAmount
            );
        } else if (
            this.selectedMattress.length > 0 &&
            this.selectedMattress.length < this.mattressAmount
        ) {
            // if less than needed
            const toCopy = this.selectedMattress.at(0);
            for (
                let i = this.selectedMattress.length;
                i < this.mattressAmount;
                i++
            ) {
                this.selectedMattress.push(toCopy.clone());
            }
        }
        
        

        // set option MATTRESS_SIZE_OPTION_ID to for each selectedMattress to correct dimension
        this.selectedMattress.forEach((m) => {
            const size = this.mattressMatchingSize.find(
                (o) => o.optionId === MATTRESS_SIZE_OPTION_ID
            );
            if (size) {
                const dimensionOption = m.options_configuration.find(
                    (o) => o.id === MATTRESS_SIZE_OPTION_ID
                );
                if (!dimensionOption) {
                    return;
                }
                dimensionOption.value = size.valueId;
            }
        });

        this.updateMattressPrices();
    }
    @action selectMattress = ({ valueId }) => {
        if (this.selectedMattressId === valueId) {
            return;
        }
        // A dormant 0 amount (a configuration loaded without a mattress) must
        // never swallow a new selection; the configurator operates with 1 or 2.
        if (valueId && this.mattressAmount < 1) {
            this.mattressAmount = 1;
        }
        this.selectedMattressId = valueId;
        var amount = this.mattressAmount;

        this.updateMattressAmountIfNeeded();

        if (valueId === 0) {
            this.selectedMattress = [];
            return;
        }

        for (let i = 0; i < amount; i++) {
            var newMattress = this.mattress
                .find((m) => m.valueId === this.selectedMattressId)
                ?.clone();
            // copy options to m
            const oldMattress = this.selectedMattress.at(i);

            newMattress.options_configuration.forEach((option) => {
                const size = this.mattressMatchingSize.find(
                    (o) => o.optionId === option.id
                );
                if (size) {
                    option.value = size.valueId;
                    return;
                }
                if (oldMattress) {
                    const oldValue = oldMattress.options_configuration.find(
                        (o) => o.id === option.id
                    )?.value;
                    console.log(
                        `Copy option ${option.id} from ${oldMattress.id} to ${newMattress.id} ${option.value} -> ${oldValue}`
                    );
                    option.value = oldValue;
                    if(!oldValue){
                        // if no value in old mattress select first option
                        const firstOption = option.options.at(0);
                        option.value = firstOption.valueId;
                        console.log(`Not found value in old mattress, select first option -> ${firstOption.name}`);
                    }
                }
            });

            if (newMattress) {
                // replace at index or add if not exist
                this.selectedMattress[i] = newMattress;
            }
        }
        // cut to amout
        if (this.selectedMattress.length > amount) {
            this.selectedMattress.length = amount;
        }

        // this.mattress.forEach((m) => {
        //     m.options_configuration.forEach((option) => {
        //         const size = this.mattressMatchingSize.find((o) => o.optionId === option.id);
        //         if(size){
        //             option.value = size.valueId;
        //         }
        //     })
        // })
    };

    // Mattress
    @observable selectedTopMattressId = 0;
    @observable selectedTopMattress: ProductModel[] = [];
    @action updateTopMattressAmountIfNeeded() {
        if (this.selectedTopMattressId === 0) {
            this.selectedTopMattress = [];
            return;
        }
        // clone if needed
        if (this.selectedTopMattress.length === 0) {
            // if no mattress selected
            var m = this.mattress
                .find((m) => m.id === this.selectedTopMattressId)
                ?.clone();
            if (m) {
                // if found
                this.selectedTopMattress.push(m);
            }
        }
        if (this.selectedTopMattress.length > this.mattressAmount) {
            // if more than needed
            this.selectedTopMattress = this.selectedTopMattress.slice(
                0,
                this.mattressAmount
            );
        } else if (
            this.selectedTopMattress.length > 0 &&
            this.selectedTopMattress.length < this.mattressAmount
        ) {
            // if less than needed
            const toCopy = this.selectedTopMattress.at(0);
            for (
                let i = this.selectedTopMattress.length;
                i < this.mattressAmount;
                i++
            ) {
                this.selectedTopMattress.push(toCopy.clone());
            }
        }
    }

    @computed get mattressTopMatchingSize() {
        // const dimensionName = this.getStepByType("radio_dimensions")?.selectedOption?.name;
        // return this.mattress_toppers.filter((m) => { 
        //     return String(m.name).toLowerCase() === String(dimensionName).toLowerCase();
        // });
        return this.mattress_toppers;
       
    }
    @action selectTopMattress = ({ valueId }) => {
        if (this.selectedTopMattressId === valueId) {
            return;
        }
        this.selectedTopMattressId = valueId;
        var amount = this.mattressAmount;

        this.updateTopMattressAmountIfNeeded();

        if (valueId === 0) {
            this.selectedTopMattress = [];
            return;
        }

        for (let i = 0; i < amount; i++) {
            var newMattress = this.mattress_toppers
                .find((m) => m.valueId === this.selectedTopMattressId)
                ?.clone();
            // copy options to m
            const oldMattress = this.selectedTopMattress.at(i);

            newMattress.options_configuration.forEach((option) => {
                // const size = this.mattressTopMatchingSize.find(
                //     (o) => o.optionId === option.id
                // );

                const dimensionName =
                    this.getStepByType("radio_dimensions")?.selectedOption
                        ?.name;
                const _option = option.options.find(
                    // (o) => o.name === dimensionName
                    (o) => this.cleanup(o.name) === this.cleanup(dimensionName)
                );
                if (dimensionName && _option) {
                    option.value = _option.valueId;
                    return;
                }
                
                if (oldMattress) {
                    const oldValue = oldMattress.options_configuration.find(
                        (o) => o.id === option.id
                    )?.value;
                    console.log(
                        `Copy option ${option.id} from ${oldMattress.id} to ${newMattress.id} ${option.value} -> ${oldValue}`
                    );
                    option.value = oldValue;
                }
            });

            if (newMattress) {
                // replace at index or add if not exist
                this.selectedTopMattress[i] = newMattress;
            }
        }
        // cut to amout
        if (this.selectedTopMattress.length > amount) {
            this.selectedTopMattress.length = amount;
        }

        this.updateTopMattressPrices();


        // this.mattress.forEach((m) => {
        //     m.options_configuration.forEach((option) => {
        //         const size = this.mattressMatchingSize.find((o) => o.optionId === option.id);
        //         if(size){
        //             option.value = size.valueId;
        //         }
        //     })
        // })
    };

    cleanup(str) {
        return String(str).replaceAll(" ", "").replaceAll("cm", "").toLowerCase();
    }

    updateTopMattressPrices() {
        
        this.mattress_toppers.forEach((m) => {
            m.options_configuration.forEach((option) => {
                const dimensionName = this.getStepByType("radio_dimensions")?.selectedOption?.name;        
                const size = option.options.find((o) => {
                    var name1 = this.cleanup(o.name);
                    var name2 = this.cleanup(dimensionName);
                    return name1 === name2;
                });
                if (size) {
                    option.value = size.valueId;
                }
            })
        })
    }
    updateMattressPrices() {
        let mattressDimensionName = null;
        if(this.mattressMatchingSize.length > 0){
            mattressDimensionName = this.mattressMatchingSize[0].name;
        }
        this.mattress.forEach((m) => {
            m.options_configuration.forEach((option) => {
                const dimensionName = this.getStepByType("radio_dimensions")?.selectedOption?.name;        
                // const size = option.options.find((o) => this.cleanup(o.name) === this.cleanup(mattressDimensionName));
                const size = option.options.find((o) => {
                    var name1 = this.cleanup(o.name);
                    var name2 = this.cleanup(mattressDimensionName);
                    return name1 === name2;
                })
                if (size) {
                    option.value = size.valueId;
                    console.log("updateMattressPrices",{mattressDimensionName, valueId: size.valueId, option, size});
                }
            })
        })
    }

    // Mattress / Sposób otwierania
    @observable selectedOpeningTypeId = 1;
    @action selectOpeningType = ({ valueId }) => {
        this.selectedOpeningTypeId = valueId;
    };

    // Mattress / Materac nawierzchniowy
    // @observable selectedTopMattressId = 1;
    // @action selectTopMattress = ({ valueId }) => {
    //     this.selectedTopMattressId = valueId;
    // };

    // Safety products
    @observable selectedSafetyProductIds: Number[] = [];
    @observable selectedSafetyProducts: ProductModel[] = [];
    @action toggleSafetyProduct = (product) => {
        if (!product || product.valueId === 0 || product.valueId === null) return;
        const index = this.selectedSafetyProductIds.indexOf(product.valueId);
        if (index >= 0) {
            this.selectedSafetyProductIds.splice(index, 1);
            this.selectedSafetyProducts = this.selectedSafetyProducts.filter(p => p.valueId !== product.valueId);
        } else {
            this.selectedSafetyProductIds.push(product.valueId);
            if (product instanceof ProductModel) {
                this.selectedSafetyProducts.push(product);
            }
        }
    };
    @action clearSafetyProducts = () => {
        this.selectedSafetyProductIds = [];
        this.selectedSafetyProducts = [];
    };

    // Legs
    @observable selectedLegId = 1;
    @action selectLeg = ({ valueId }) => {
        this.selectedLegId = valueId;
    };

    constructor() {
        makeAutoObservable(this);

        this.cart = new CartClass({
            store: this,
        });

        this.quiz = new QuizStore({
            store: this,
        });

        this.saveProject = new SaveProject({
            store: this,
        });

        this.selectedSwatches = new SelectedSwatchesStore({
            store: this,
        });

        this.fabricFilters = new FiltersStore({
            store: this,
        });

        Gtm.setStore(this);

        // const colorsList = [
        //     { label: 'Czerwony', value: 1 },
        //     { label: 'Beżowy', value: 2 },
        //     { label: 'Biały', value: 3 },
        //     { label: 'Szary', value: 4 },
        //     { label: 'Czarny', value: 5 },
        //     { label: 'Zielony', value: 6 },
        // ];
        // const characteristicsList = [
        //     { label: 'Łatwoczyszcząca', value: 1 },
        //     { label: 'Wodoodporna', value: 2 },
        //     { label: 'Ciepła', value: 3 },
        // ];
        this.fabricFilters.addFilter("colors", {
            type: "select",
            options: [
            ],
            value: [],
            defaultValue: [],
        });
        this.fabricFilters.addFilter("characteristics", {
            type: "select",
            options: [
                // { label: "Łatwoczyszcząca", value: 1 },
                // { label: "Wodoodporna", value: 2 },
                // { label: "Ciepła", value: 3 },
            ],
            value: [],
            defaultValue: [],
        });
        this.fabricFilters.addFilter("sorting", {
            type: "select",
            options: [
                // { label: "Domyślnie", value: "DEFAULT" },
                { label: lang.t('filter_sort_asc'), value: "ASC" },
                { label: lang.t('filter_sort_desc'), value: "DESC" },
            ],
            value: "ASC",
            defaultValue: "ASC",
        });

        window.addEventListener("resize", this.onResize, { passive: true });
        window.addEventListener("scroll", this.onScroll, { passive: true });
        document.addEventListener("keydown", this.onKeyDown.bind(this), {
            passive: true,
        });
        this.onResize();

        document.removeEventListener("click", this.onProductClick);
        document.addEventListener("click", this.onProductClick);
        setTimeout(() => {
            // this.loadConfiguration();
            this.onResize();
        }, 200);


        const u = new URL(window.location.href);
        let id = u.searchParams.get("id");
        let hash = u.searchParams.get("hash");
        let basketConfig = u.searchParams.get("basketConfig");
        if (basketConfig) {
            console.log('[Store] basketConfig param detected', {
                basketConfig,
                featureEnabled: isFeatureEnabled(),
            });
        }
        // MYB-121: basket configuration takes precedence over the user save/share config
        if (isFeatureEnabled() && basketConfig) {
            this.loadBasketConfiguration(basketConfig);
        } else if (id && hash) {
            this.saveProject.loadProjectFromUrl();
        }

        // MYB-121: fetch the entire basket (including configuration links) on page load
        if (isFeatureEnabled()) {
            this.cart.loadCart();
        }

        
    }
    onProductClick = (e) => {
        if (e.target && e.target.dataset.confProductId !== undefined) {
            this.loadConfiguration({
                productId: e.target.dataset.confProductId,
            });


        }
    };

    onKeyDown(e) {
        // if ESC is pressed
        if (e.keyCode === 27) {
            console.log("ESC");
            this.openOnExit();
        }
    }

    @observable isPreviewOpen = false;
    @observable previewImageUrl = null;
    @observable previewSize = "md";
    @observable previewAspectRatio = "none";
    @observable previewAllowZoom = false;
    /**
     *
     * @param {"dimensions"|"person"|null} mode
     */
    @action togglePreviewMode(mode) {
        if (this.previewMode.includes(mode)) {
            this.previewMode = this.previewMode.filter((m) => m !== mode);
        } else {
            this.previewMode = [mode];
        }

    }
    /**
     *
     * @param {Array<"dimensions"|"person"|null>} mode
     */
    @observable previewMode = [];

    processImageUrl({ dimensions = false, person = false, preview = false } = {}) {
        const confOptions = this.product?.options_configuration.filter(
            (option) => option.change_model_view
        );
        if (confOptions) {
            const baseUrl = `${BASE_URL}/model/pe${this.product.id}__`; //__pe159-pe4599_pe162-pe2977_pe163-pe4117.png`
            // const baseUrl = `https://contenthub.ar-cloud.app/photoModel/143__`; //__pe159-pe4599_pe162-pe2977_pe163-pe4117.png`
            const optionsList = confOptions.flatMap((option) => {
                const rawValue = preview && option.step?.previewValue ? option.step.previewValue : option.value;
                const prefix_option = option.prefix_option ?? "pe";
                const prefix_value = option.prefix_value ?? "pe";

                if (Array.isArray(rawValue)) {
                    const sorted = sortMultiSelectValues(rawValue, option.step?.options || []);
                    return sorted.map(v => ({
                        id: option.id,
                        stepType: option.step?.type,
                        value: v,
                        prefix_option,
                        prefix_value,
                    }));
                }

                return [{
                    id: option.id,
                    stepType: option.step?.type,
                    value: rawValue,
                    prefix_option,
                    prefix_value,
                }];
            });
            // if no dimension dont send size params
            
            if (dimensions) {
                optionsList.push({
                    id: "dimensions",
                    value: "show",
                    prefix_option: "s",
                    prefix_value: "s",
                });
            }
            if (person) {
                optionsList.push({
                    id: "person",
                    value: "show",
                    prefix_option: "s",
                    prefix_value: "s",
                });
            }

            console.log("optionsList", optionsList);

            const optionsStr = optionsList
                .filter((option) => {
                    // dont send dimension when not needed
                    if (!dimensions) {
                        if (option.stepType === "radio_dimensions") {
                            return false;
                        }
                    }
                    return true;
                })
                .map((option) => {
                    return `${option.prefix_option}${option.id}-${option.prefix_value}${option.value}`;
                })
                .join("_");
            return `${baseUrl}${optionsStr}.png`;
        }
        return null;
        // return publicUrl("/assets/photo.png");
    }
    /**
     * Example: https://mybed.vps.ar-range.app/2/01KATY6K247Z1X7KGCD0ACYF3M/configurator/1/model/pe497__pe159-pe4599_pe162-pe2977_pe163-pe4117.png
     */
    @computed get renderImageUrl() {
        return this.processImageUrl({
            dimensions: this.previewMode.includes("dimensions"),
            person: this.previewMode.includes("person"),
        });
    }
    @computed get renderPlainImageUrl() {
        return this.processImageUrl({
            dimensions: false,
            person: false,
        });
    }
    @computed get renderDimensionsImageUrl() {
        return this.processImageUrl({
            dimensions: false,
            preview: false
        });
    }
    @computed get renderDimensionsPreviewImageUrl() {
        return this.processImageUrl({
            dimensions: true,
            preview: true
        });
    }

    @computed get renderPersonImageUrl() {
        return this.processImageUrl({
            person: true,
        });
    }
    @computed get renderPersonPreviewImageUrl() {
        return this.processImageUrl({
            person: true,
            preview: true
        });
    }
    @action openPreview(imageUrl, size = "md", aspectRatio = "none", allowZoom = false) {
        this.previewSize = size;
        this.previewAspectRatio = aspectRatio;
        this.previewAllowZoom = allowZoom;
        this.previewImageUrl = imageUrl;
        this.isPreviewOpen = true;
    }
    @action closePreview() {
        this.previewImageUrl = null;
        this.isPreviewOpen = false;
        this.previewAllowZoom = false;
    }

    @action scrollTo(id, { animate = true } = {}) {
        const offsetFromTop = 20;
        const el = document.querySelector(`.App .grid-controls`);

        // check if number
        if (isNaN(id) === false) {
            el.scrollTo({
                top: Math.max(0, parseInt(id) - offsetFromTop),
                behavior: animate ? "smooth" : "instant",
            });
            return;
        }
        const to = document.querySelector(`.App .grid-controls #${id}`);
        const render = document.querySelector(".App .grid-render");
        const top = document.querySelector(".App .grid-top");
        if (el && to) {
            const topHeight = 0;
            // let renderHeight = render.clientHeight || 0;
            const renderHeight = 0;
            // skip render if is on left side
            // if(renderHeight > window.innerHeight/2){
            //     renderHeight = 0;
            // }
            console.log({
                topHeight,
                renderHeight,
                offsetFromTop,
                to: to.offsetTop,
            });
            el.scrollTo({
                top: to.offsetTop - renderHeight - topHeight - offsetFromTop,
                behavior: animate ? "smooth" : "instant",
            });
        }
    }

    showModal() {
        this.isOpen = true;
        document.documentElement.classList.add('configurator-visible');
    }
    hideModal() {
        this.isOpen = false;
        document.documentElement.classList.remove('configurator-visible');
    }

    /**
     * MYB-121: loads a basket configuration and opens the configurator in
     * update mode, pre-loaded with the saved options.
     */
    @action async loadBasketConfiguration(id) {
        if (!isFeatureEnabled() || !id) {
            return null;
        }
        console.log('[Store] loadBasketConfiguration', id);
        this.pendingRequest = true;
        try {
            const response = await getBasketConfiguration(id);
            const record = response?.basketConfiguration || response;
            if (!record || record.status === false) {
                const notFound = new Error(record?.message || 'Basket configuration not found');
                notFound.basketConfigurationNotFound = true;
                throw notFound;
            }
            const configuration = record.configuration;
            const productId = record.productId || configuration?.productId;
            await this.loadConfiguration({ productId });
            if (configuration) {
                this.saveProject.updateConfiguration(configuration);
            }
            this.cart.basketConfigId = id;
            this.isBasketEditMode = true;
            return record;
        } catch (err) {
            console.error('[Store] loadBasketConfiguration failed', err);
            const isNotFound = Boolean(err?.basketConfigurationNotFound)
                || err?.response?.status === 404
                || /not\s*found/i.test(String(err?.message || ''));
            if (isNotFound) {
                // Stale/invalid basket link: drop the param and stay on the PDP.
                this.cleanBasketConfigUrl();
                return null;
            }
            swalAlert({
                title: lang.t('error'),
                html: err.toString(),
            });
            return null;
        } finally {
            this.pendingRequest = false;
        }
    }

    /**
     * MYB-121: stamps the current PDP history entry with the basket configuration
     * id so the browser Back button returns to the configurator (not a bare PDP).
     */
    @action commitBasketReturnUrl() {
        if (!isFeatureEnabled() || !this.cart.basketConfigId) {
            return;
        }
        const u = new URL(window.location.href);
        u.searchParams.set('basketConfig', this.cart.basketConfigId);
        window.history.replaceState(
            { ...(window.history.state || {}), basketConfig: this.cart.basketConfigId },
            '',
            u
        );
        console.log('[Store] commitBasketReturnUrl', this.cart.basketConfigId);
    }

    @action async loadConfiguration({ productId = null } = {}) {
        if (!productId) {
            productId = 497;
        }
        console.log("loadConfiguration", { productId });
        this.pendingRequest = true;
        this.selectedMaterials = [];
        this.selectedCategoryId = 1;
        this.selectedSizeId = 1;
        this.currentOpenAccordion = null;
        this.selectedMattressId = 1;
        this.steps.clear();
        this.config = null;
        this.product = null;
        this.mattress = [];
        this.mattress_toppers = [];
        this.safety_products = [];
        this.cart.clear();

        try {
            this.showModal();

            const response = await getProduct(productId);
            this.config = response;
            this.parseData(response);
            this.cart.loadCart();

            if(this.default_preset){
                this.saveProject.updateConfiguration(this.default_preset);
            }else{
                this.preselectDefaults();
            }

            Gtm.setStore(this);
            Gtm.push({
                event: "konfigurator_click",
                ecommerce: {
                    button_name: "skonfiguruj i kup",
                    button_typ: "start",
                    option: "",
                    etap: 0,
                    items: [
                        {
                            item_name: this.product.name,
                            item_id: this.product.id,
                            item_brand: "MyBed",
                            item_category: "Łóżka",
                            item_variant: Gtm.getVariantStr(),
                        }
                    ]
                }
            });
            Clarity.push("konfigurator_click - start - skonfiguruj i kup");

            this.hasUnsavedChanges = false;

            await delay(333);
        } catch (err) {
            console.error(err);
            swalAlert({
                title: lang.t('error'),
                html:
                    err.toString() +
                    `<pre style="font-size: 9px; line-height: 1.2; background-color: #eee; padding: 10px; word-break: break-all;white-space: pre-wrap;">${err.stack}</pre>`,
            });
        } finally {
            this.pendingRequest = false;
        }
    }

    @action preselectDefaults() {
        console.groupCollapsed("preselectDefaults");
        this.sortedStepsFlat.forEach((step) => {
            if (step.options?.length > 0) {
                let availableOptions = step.options.filter(
                    (option) => option.isAvailable
                );
                // filtered options 
                availableOptions = availableOptions.filter(
                    (option) => !option.custom_size
                )
                if (availableOptions.length > 0) {
                    switch (step.type) {
                        case 'fabric_component': // fabric
                            this.selectedCategoryId =
                                this.fabricCollectionFiltered[0].id;
                            this.selectedFabricId =
                                this.fabricCollectionFiltered[0].fabrics[0].valueId;
                            this.updateOption(
                                availableOptions[0].optionId,
                                this.selectedFabricId,
                                {tracking: false}
                            );
                            break;
                        
                        case 'select_built-in_mattress_hardness': // Twardosc wbudowanego materasa
                            const option = availableOptions.find(o=>String(o.name).toLowerCase().includes('h3'));
                            if(option){

                                this.updateOption(
                                    option.optionId,
                                    option.valueId,
                                    {tracking: false}
                                );
                                break;
                            }

                        default:
                            var optionId = availableOptions[0].optionId ?? step.id;
                            this.updateOption(
                                optionId,
                                availableOptions[0].valueId,
                                {tracking: false}
                            );
                    }
                    // switch (step.id) {
                    //     case 163: // fabric
                    //         this.selectedCategoryId =
                    //             this.fabricCollectionFiltered[0].id;
                    //         this.selectedFabricId =
                    //             this.fabricCollectionFiltered[0].fabrics[0].valueId;
                    //         this.updateOption(
                    //             availableOptions[0].optionId,
                    //             this.selectedFabricId
                    //         );
                    //         break;
                    //     case 171: // Twardosc wbudowanego materasa
                    //         const option = availableOptions.find(o=>String(o.name).toLowerCase().includes('h3'));
                    //         if(option){

                    //             this.updateOption(
                    //                 option.optionId,
                    //                 option.valueId
                    //             );
                    //             break;
                    //         }
                    //     default:
                    //         var optionId = availableOptions[0].optionId ?? step.id;
                    //         this.updateOption(
                    //             optionId,
                    //             availableOptions[0].valueId
                    //         );
                    // }
                }
            }
        });
        console.groupEnd();
    }

    fetchOptions(type) {
        var options = this[type];
        if (!options || options.length === 0) {
            return null;
        }
        return options;
    }

    parseDefaultPresets(response) {
        
        try {
            this.default_preset = null;
            const items = response?.product?.ch_extra_data?.items;
            if(items && items.length > 0 && items[0]?.attributes?.default_preset) {
                this.default_preset = JSON.parse(items[0].attributes.default_preset);
            }
            
        } catch (err) {
            console.error(err);
        }
    }
    parseData(response) {
        const self = this;

        // parse operations
        function optionsAsFlatArray(groups) {
            var optionsFlatArray = [];
            groups.forEach((group) => {
                group.attributes.steps?.forEach((step) => {
                    step.attributes.components?.forEach((component) => {
                        component.attributes.product_option?.forEach((po) => {
                            optionsFlatArray.push(po);
                        });
                    });
                });
            });
            return optionsFlatArray;
        }
        function findStepGroupByOptionId(option_id, groups) {
            return groups.find((group) =>
                group.attributes.steps.find((step) => {
                    return step.attributes.components?.find((component) =>
                        component.attributes.product_option.find((po) => {
                            return po.option_id === option_id;
                        })
                    );
                })
            );
        }
        function findStepGroupByType(type, groups) {
            for (const group of groups) {
                for (const step of group.attributes.steps) {
                    const components = step.attributes?.components || [];
                    for (const component of components) {
                        if (component.attributes.type === type) {
                            return {
                                component,
                                group,
                                step,
                            };
                        }
                    }
                }
            }
            return {
                component: null,
                group: null,
                step: null,
            };
        }
        function findOptionByOptionId(option_id, groups) {
            var optionsFlatArray = [];
            groups.forEach((group) => {
                group.attributes.steps?.forEach((step) => {
                    step.attributes.components?.forEach((component) => {
                        component.attributes.product_option?.forEach((po) => {
                            if (po.option_id === option_id) {
                                optionsFlatArray.push(po);
                            }
                        });
                    });
                });
            });

            return optionsFlatArray.find(
                (option) => option.option_id === option_id
            );
        }


        this.options_configuration =
            response.product.options_configuration || [];
        this.options_flat_array = optionsAsFlatArray(response.step_groups);

        this.parseDefaultPresets(response);

        this.mattress = (response.mattress || []).map((mattress) => {
            const p = new ProductModel({ store: this, ...mattress });
            p.preselectDefaults();
            return p;
        });
        this.mattress_toppers = (response.mattress_toppers || []).map(
            (mattres) => {
                const p = new ProductModel({ store: this, ...mattres });
                p.preselectDefaults();
                return p;
            }
        );
        this.safety_products = (response.safety_products || []).map((product) => {
            const p = new ProductModel({ store: this, ...product });
            p.preselectDefaults();
            return p;
        });

        if (response.fabric_sample.length > 0) {
            this.sampleFabricProdcut = new ProductModel({
                store: this,
                ...response.fabric_sample[0],
            });
        }
        if (response.product) {
            this.product = new ProductModel({
                store: this,
                ...response.product,
            });
        }

        // parse steps from options_configuration
        // this.options_configuration.forEach((option, index) => {
        //     const stepGroup = findStepGroupByOptionId(option.id, response.step_groups) || {};
        //     const step = findOptionByOptionId(option.id, response.step_groups) || {};
        //     const order = option.order !== undefined ? parseInt(option.order) * 100 : index * 100;
        //     this.steps.set(option.id, {
        //         id: option.id,
        //         type: step.type || option.type,
        //         group_id: stepGroup.id,
        //         name: step.name || option.name,
        //         attributes: {
        //             required: option.required,
        //             stock: option.stock,
        //             values: option.values,
        //         },
        //         done: false,
        //         active: false,
        //         order,
        //         stepGroup: {
        //             id: stepGroup.id,
        //             name: stepGroup.name
        //         },
        //         options: option.values,
        //     });
        // });

        // Also include steps from step_groups if they exist
        if (response.step_groups) {
            var steps = [];
            response.step_groups.forEach((stepGroup) => {
                const group_order = parseInt(stepGroup.attributes?.order) * 100;
                

                stepGroup.attributes?.steps?.forEach((step, index) => {
                    let order = group_order;
                    let components = step.attributes?.components?.map((c) => {
                        const productOptionId = parseInt(
                            c.attributes?.product_option.at(0)?.option_id
                        );
                        const shoperOption = this.options_configuration.find(
                            (oc) => oc.id === productOptionId
                        );

                        let options;
                        if (c.attributes?.type === 'select_safety_type') {
                            // const safetyOpts = (response.safety_options || []).map(this.parseOption);
                            const safetyOpts = this.safety_products;
                            const configOpts = shoperOption?.values.map(this.parseOption) || [];
                            options = [...safetyOpts, ...configOpts];
                        } else {
                            options = shoperOption?.values.map(
                                this.parseOption
                            );
                        }
                        const isNotExtraOption =
                            this.product.extraOptionsIds.includes(
                                productOptionId
                            ) === false;
                        const isNotProductOption =
                            this.product.options_configuration.some(
                                (oc) => oc.id === productOptionId
                            ) === false;
                        // if(isNotExtraOption && isNotProductOption){
                        //     console.log('Removing ' + c.name, {productOptionId, isNotExtraOption, isNotProductOption});
                        //     return null;
                        // }

                        const type = c.attributes?.type || shoperOption?.type;

                        return {
                            ...c,
                            order:
                                order + c.attributes?.order !== undefined
                                    ? parseInt(c.attributes?.order)
                                    : index,
                            id: productOptionId || c.id,
                            name: c.name,
                            options: options,
                            stock: shoperOption?.stock,
                            required: shoperOption?.required,
                            type: type,
                            value: null,
                            stepGroup
                        };
                    });

                    let type = null;
                    let options = null;
                    let data = step;
                    if (components?.length === 1) {
                        data = {
                            ...step,
                            ...components[0],
                        };
                        options = components[0]?.options;
                        type = components[0].type;
                        components = null;
                    }else if(components?.length > 1){
                        type = step.attributes?.step_type;
                    }

                    // if there is no option inline then fetch from store
                    if (!options) {
                        // debugger;
                        options = this.fetchOptions(type);
                    }

                    const step_order =
                        step.attributes?.order !== undefined
                            ? parseInt(step.attributes.order)
                            : index;
                    order += step_order;

                    // dont add if there is no components
                    if (!components?.length && !options?.length) {
                        console.warn(
                            `Step ${step.name}:${type} has no components or options, skipping`
                        );
                        return;
                    }
                    steps.push({
                        ...data,
                        order,
                        type,
                        options,
                        components,
                        stepGroup
                    });
                });
            });

            const extraOptionsIds = store.product.extraOptionsIds;
            const configurationOptionsIds =
                store.product.options_configuration.map((oc) => oc.id);

            steps = steps
                .map((step) => {
                    const checkIfValid = ({
                        step,
                        extraOptionsIds,
                        configurationOptionsIds,
                    }) => {
                        const isNotExtraOption =
                            extraOptionsIds.includes(step.id) === false;
                        const isNotProductOption =
                            configurationOptionsIds.includes(step.id) === false;
                        const isValid =
                            (isNotExtraOption && isNotProductOption) === false;
                        console.log({ extraOptionsIds });
                        if (!isValid) {
                            console.warn(
                                `Step ${step.name} is not extra option: ${isNotExtraOption}, is not product option: ${isNotProductOption}`
                            );
                        }
                        return isValid;
                    };

                    if (step.components) {
                        step.components = step.components.filter((c) =>
                            checkIfValid({
                                step: c,
                                extraOptionsIds,
                                configurationOptionsIds,
                            })
                        );
                    }
                    const isStepValid = checkIfValid({
                        step,
                        extraOptionsIds,
                        configurationOptionsIds,
                    });
                    const hasValidComponents = step.components?.length > 0;
                    if (!isStepValid && hasValidComponents) {
                        console.warn(
                            `But step ${step.name} is valid: ${isStepValid}, has valid components: ${hasValidComponents}`
                        );
                    }
                    if (!isStepValid && !hasValidComponents) {
                        return null;
                    }

                    return step;
                })
                .filter((step) => !!step);

            console.log(steps);
            // debugger;
            steps.forEach((step) => {
                this.steps.set(
                    step.id,
                    new StepModel({
                        ...step,
                        store: this,
                        components: step.components?.sort((a,b) => a.order - b.order).map((c) => {
                            return new StepModel({
                                store: this,
                                ...c,
                            });
                        }),
                    })
                );
            });
        }

        // // add mattress
        // if(this.mattress.length > 0){
        //     const { component: mattressStep, group, step} = findStepGroupByType('mattress', response.step_groups);
        //     if(mattressStep){

        //         this.steps.set(mattressStep.id, new StepModel({
        //             store: this,
        //             id: mattressStep.id,
        //             type: mattressStep.attributes?.type,
        //             group_id: group?.id,
        //             name: mattressStep.name,
        //             required: true,
        //             stock: false,
        //             options: this.mattress,
        //             value: null,
        //             done: false,
        //             active: false,
        //             order: parseInt(mattressStep.attributes?.order) + 900,
        //             stepGroup: {
        //                 id: group?.id,
        //                 name: group?.name,
        //                 order: parseInt(group?.attributes?.order) * 100,
        //             },
        //         }));
        //     }
        // }
        // // add mattress
        // if(this.mattress_toppers.length > 0){
        //     const { component: mattressStep, group, step} = findStepGroupByType('select_built-in_mattress', response.step_groups);
        //     // debugger;
        //     if(mattressStep){

        //         this.steps.set(mattressStep.id, new StepModel({
        //             store: this,
        //             id: mattressStep.id,
        //             type: mattressStep.attributes?.type,
        //             group_id: group?.id,
        //             name: mattressStep.name,
        //             required: true,
        //             stock: false,
        //             options: this.mattress_toppers,
        //             value: null,
        //             done: false,
        //             active: false,
        //             order: parseInt(mattressStep.attributes?.order) + 900,
        //             stepGroup: {
        //                 id: group?.id,
        //                 name: group?.name,
        //                 order: parseInt(group?.attributes?.order) * 100,
        //             },
        //         }));
        //     }
        // }

        // now go through this.options_configuration and add to steps all options that are not in step_groups already
        this.options_configuration.forEach((option) => {
            var step_option = this.options_flat_array.find(
                (option_flat) => option_flat.option_id === option.id
            );
            const noOption = !this.steps.has(option.id) && !step_option;

            const options = (option.values || []).map(this.parseOption);

            // if(option.id === 162) {
            //     debugger;
            // }

            if (noOption) {
                this.steps.set(
                    option.id,
                    new StepModel({
                        store: this,
                        id: option.id,
                        type: option.type,
                        group_id: null,
                        name: option.name,

                        required: option.required,
                        stock: option.stock,
                        options: options,
                        value: null,

                        done: false,
                        active: false,
                        order: parseInt(option.order) + 900,
                        stepGroup: null,
                    })
                );
            }
        });

        

        this.fabric_properties = response.fabric_properties;
        this.fabric_features = response.fabric_features;

        // parse fabris
        // this.fabrics = response.fabric.map((f) => {
        //     return new FabricModel({ ...f, store: this });
        // });

        this.fabrics = this.getStepOptionsByType("fabric_component")?.map(
            (option) => {
                // debugger;
                if (!option.ch_extra_data?.items[0]) {
                    console.error(option);
                    throw new Error(
                        "ch_extra_data.items.items[0] is undefined"
                    );
                }
                var data = option.ch_extra_data.items[0];

                return new FabricModel({ ...data, store: this });
            }
        );

        this.fabric_collection = response.fabric_collection.map((fc) => {
            return new FabricCollectionModel({ ...fc, store: this });
        });

        // setup filters
        this.fabricFilters.setOptions(
            "characteristics",
            this.fabric_properties.map((fp) => {
                return {
                    value: fp.id,
                    label: fp.name,
                    iconName: fp.attributes?.icon_name || ''
                };
            })
        );
        this.fabricFilters.setOptions(
            "colors",
            this.fabricsColorGroups.map((ff) => {
                return {
                    value: ff.id,
                    label: ff.name,
                };
            })
        );

        this.parseUpsellData(response);

        this.parseDimensionsAttributes(response);
    }

    @observable upsellCategories: Array<{name: string, id: number}> = [];
    @observable upsellProducts: ProductModel[] = [];
    @computed get defaultCategoryId() {
        if(this.upsellCategories?.length > 0){
            return this.upsellCategories[0].id;
        }
        return null;
    }
    parseUpsellData(response) {
        if(response.upsell_products?.length > 0){
            this.upsellProducts = response.upsell_products.map((p) => {
                return new ProductModel({ ...p, store: this });
            });
            this.upsellProducts.forEach((p) => {
                p.preselectDefaults();
            })
        }
        if(response.upsell_categories?.length > 0){
            this.upsellCategories = response.upsell_categories.map((p) => {
                return {
                    ...p
                }
            });
        }
    }
    getUpsellProductsFromCategory(categoryId) {
        return this.upsellProducts.filter((p) => p.upsell_category_id === categoryId);
    }

    @computed get extraSteps() {
        
        if (this.product) {
            const extraOptionsIds = this.product.extraOptionsIds || [];
            return this.sortedStepsFlat.filter((step) => {
                // This step is different. Event that it is not defined by extraSteps and extraOptionsIds it can be extra product.
                if (step.type === "select_safety_type" && this.selectedSafetyProducts.length > 0) {
                    return true;
                }
                return  extraOptionsIds.includes(step.id) || step.extra
            });
            
        }

        return [];
        
    }
    @computed get extraProdcutsByStep() {
        var products: Array<{ step: StepModel, products: Array<ProductModel> }> = [];
        this.extraSteps.forEach((step) => {
            const stepProducts: Array<ProductModel> = [];
            if (!step.multiSelect && !step.selectedOption) {
                products.push({ step, products: stepProducts });
                return;
            }

            switch (step.type) {
                case "mattress":
                    this.selectedMattress.forEach((m) => {
                        stepProducts.push(m);
                    });
                    break;
                case "mattress_toppers":
                    this.selectedTopMattress.forEach((m) => {
                        stepProducts.push(m);
                    });
                    break;
                case "additional_mattress":
                    this.selectedAdditionalMattress.forEach((m) => {
                        stepProducts.push(m);
                    });
                break;
                case "select_safety_type":
                    this.selectedSafetyProducts.forEach((p) => {
                        stepProducts.push(p);
                    });
                    break;
            }
            products.push({ step, products: stepProducts });
        });
        return products;
    }
    @computed get extraProdcuts() {
        return this.extraProdcutsByStep.flatMap(({ products }) => products);
    }

    /**
     *
     * @param {object} option
     * @returns {OptionModel}
     */
    parseOption = (option) => {
        let price = 0;
        const ch_extra_data =
            option.ch_extra_data?.items.length > 0
                ? option.ch_extra_data.items[0]
                : null;
        if (ch_extra_data && ch_extra_data.price !== undefined) {
            price = parseFloat(ch_extra_data.price);
        }

        return new OptionModel({
            ...option,
            ...ch_extra_data,
            price,
            store: this,
        });

        // return {
        //     ...option,
        //     price
        // }
    };

    @observable dimensionAttributes: Array<{
        name: string,
        value: string,
        label: string,
    }> = [];

    /**
     *
     * @param {*} response
     */
    parseDimensionsAttributes(response) {
        if (
            response?.product?.ch_extra_data?.items?.length > 0 &&
            typeof response.product.ch_extra_data.items[0].attributes ===
                "object"
        ) {
            let attributes =
                response.product.ch_extra_data.items[0].attributes;
            if(attributes && !attributes['height']){
                attributes['height'] = 0;
            }
            this.dimensionAttributes = Object.keys(attributes)
                .map((key) => {
                    let label = "";
                    switch (key) {
                        case "extra_length":
                            label = lang.t('dim_length');
                            break;
                        case "extra_width":
                            label = lang.t('dim_width');
                            break;
                        case "height":
                            label = lang.t('dim_height');
                            attributes['height'] = attributes['extra_height'];
                            break;
                        case "mattress_recess_depth":
                        // case "seating_depth":
                            label = lang.t('dim_mattress_depth');
                            break;
                        case "frame_thickness":
                            label = lang.t('dim_frame_thickness');
                            break;
                        case "headboard_thickness":
                            label = lang.t('dim_headboard_thickness');
                            break;
                        case "frame_slat_count":
                            label = lang.t('dim_slat_count');
                            break;
                        case "depth_bedding_container":
                            label = lang.t('dim_drawer_depth');
                            break;
                    }
                    // debugger;
                    return {
                        name: key,
                        label: label,
                        value: attributes[key],
                    };
                })
                .filter((attr) => !!attr.label)
                .sort((a, b) => {
                // sort them by name in order: extra_width, extra_length, height, mattress_recess_depth, frame_thickness, headboard_thickness, frame_slat_count
                const order = [
                    "extra_width",
                    "extra_length",
                    "height",
                    "mattress_recess_depth",
                    "frame_thickness",
                    "headboard_thickness",
                    "frame_slat_count",
                    "depth_bedding_container",
                ];
                return order.indexOf(a.name) - order.indexOf(b.name);
            })
        }
    }

    getStepByOptionId(option_id): ?StepModel {
        const mainOption = this.steps.get(option_id);
        if (mainOption) {
            return mainOption;
        }

        for (const step of this.sortedSteps) {
            if (step.components) {
                for (const component of step.components) {
                    if (component.id === option_id) {
                        return component;
                    }
                }
            }
        }

        return null;
    }
    getStepByType(type): ?StepModel {
        const mainOption = this.sortedStepsFlat.find(
            (step) => step.type === type
        );
        if (mainOption) {
            return mainOption;
        }

        for (const step of this.sortedSteps) {
            if (step.components) {
                for (const component of step.components) {
                    if (component.type === type) {
                        return component;
                    }
                }
            }
        }

        return null;
    }
    getNextStep(stepType) {
        const index = this.sortedSteps.findIndex((step) => step.type === stepType);
        if (index < this.sortedSteps.length - 1) {
            return this.sortedSteps[index + 1];
        }
        return null;
    }

    getStepOptionsByType(type) {
        const mainOption = Array.from(this.steps.values()).find(
            (option) => option.type === type
        );
        if (mainOption?.options) {
            // debugger;
            return mainOption.options;
        }

        for (const step of this.sortedSteps) {
            if (step.components) {
                for (const component of step.components) {
                    if (component.type === type) {
                        // debugger;
                        return component.options;
                    }
                }
            }
        }

        return null;
    }

    @action updateOption(option_id, value, {tracking = true} = {}) {
        console.groupCollapsed("updateOption", { option_id, value });
        const step = this.getStepByOptionId(option_id);
        let prevStepValue;
        const o = this.product.options_configuration.find(
            (o) => o.id === option_id
        );
        if (o) {
            if (Array.isArray(value)) {
                const matchingOption = o.options.find(opt => value.includes(opt.valueId));
                if (matchingOption) {
                    o.value = matchingOption.valueId;
                    o.previewValue = matchingOption.valueId;
                }else{
                    o.value = null;
                    o.previewValue = null;
                }
            } else {
                o.value = value;
                o.previewValue = value;
            }
        }
        if(!step){
            console.warn('Step not found', { option_id, value });
            return false;
        }

        if (step) {
            prevStepValue = step.value;
            step.value = value;
            step.previewValue = value;
            console.log(`Updating step ${step.name} to ${step.value} -> ${step.options?.find((o) => o.valueId === step.value)?.name ?? 'Unknown'}`);

            if(step.type === 'fabric_component'){
                this.selectedFabricId = value;
            }
        }

        // deselect not available options
        this.sortedStepsFlat.forEach((s) => {
            if (s.options) {
                if (Array.isArray(s.value)) {
                    const availableValues = s.value.filter(val => {
                        const opt = s.options.find(o => o.valueId === val);
                        return opt && opt.isAvailable !== false;
                    });
                    if (availableValues.length !== s.value.length) {
                        console.log(`Deselect unavailable options from step ${s.name}`);
                        s.value = availableValues;
                        s.previewValue = availableValues;
                        const oConf = this.product.options_configuration.find(o => o.id === s.id);
                        if (oConf) { oConf.value = availableValues; oConf.previewValue = availableValues; }
                        if (s.type === 'select_safety_type') {
                            this.selectedSafetyProductIds = [...availableValues];
                            this.selectedSafetyProducts = this.selectedSafetyProducts.filter(p => availableValues.includes(p.valueId));
                        }
                    }
                } else {
                    const selectedOption = s.options.find(
                        (option) => option.valueId === s.value
                    );

                    if (selectedOption && selectedOption.isAvailable === false) {
                        console.log({ step: s, selectedOption });
                        console.log(
                            `Deselect not available option ${s.value} from step ${s.name}`
                        );
                        this.updateOption(s.id, null, {tracking: false});
                    }
                }
            }
        });

        // update related
        if (
                        step.type === "radio_dimensions" &&
            this.sortedStepsFlat.find((step) => step.type === "mattress")
        ) {
            var s = this.sortedStepsFlat.find(
                (step) => step.type === "mattress"
            );
            if (s && s.value !== 0) {
                store.selectMattress({ valueId: 0 });
                this.updateOption(s.id, 0, {tracking: false});
            }
            this.updateMattressPrices();
        }
        
        if (
                        step.type === "radio_dimensions" &&
            this.sortedStepsFlat.find((step) => step.type === "mattress_toppers")
        ) {
            var s = this.sortedStepsFlat.find(
                (step) => step.type === "mattress_toppers"
            );
            if (s && s.value !== 0) {
                store.selectTopMattress({ valueId: 0 });
                this.updateOption(s.id, 0, {tracking: false});
            }


            this.updateTopMattressPrices();
            

        }


        if(step.type === 'select_frame' && prevStepValue !== step.value){
            this.onFrameChanged({prevStepValue, stepValue: step.value});
        }

        // store.getStepByOptionId(OPTION_DRAWER_FILL).selectedOption
        // if(step.id === OPTION_DRAWER_FILL && prevStepValue !== step.value){
        if(step.type === 'select_drawer_fill' && prevStepValue !== step.value){
            this.onDrawerFillChanged({prevStepValue, stepValue: step.value});
        }

        // onDimensionChanged
        if(step.type === 'radio_dimensions' && prevStepValue !== step.value){
            this.onDimensionChanged({prevStepValue, stepValue: step.value});
        }



        if(step.selectedOption && step.optionsAvailable.length > 0){
            
            if (tracking) {
                Gtm.setStore(this);
                Gtm.push({
                    event: "konfigurator_click",
                    ecommerce: {
                        button_name: String(step.name || o.name).toLowerCase(),
                        button_typ: "sekcja",
                        option: String(step.selectedOption?.name ?? o.selectedOption?.name ?? '').toLowerCase(),
                        etap: step.stepNumber ?? 1,
                        value: this.cart.totalPrice,
                        items: [
                            {
                            item_name: "Łóżko Adele",
                            item_id: "30",
                            item_brand: "MyBed",
                            item_category: "Łóżka",
                            item_variant: Gtm.getVariantStr(),
                            }
                        ]
                    }
                });
                var _bn = String(step.name || o.name).toLowerCase();
                Clarity.push(`konfigurator_click - sekcja - ${_bn}`);
            }

            this.hasUnsavedChanges = true;
        }
        console.groupEnd();


    }
    @action updateOptionPreview(option_id, value) {
        console.groupCollapsed("updateOptionPreview", { option_id, value });
        const step = this.getStepByOptionId(option_id);
        let prevStepValue;
        const o = this.product.options_configuration.find(
            (o) => o.id === option_id
        );
        // if (o) {
        //     o.value = value;
        // }

        if (step) {
            prevStepValue = step.value;
            step.previewValue = value;
            console.log(`Updating step ${step.name} to ${step.previewValue} -> ${step.options?.find((o) => o.valueId === step.previewValue)?.name ?? 'Unknown'}`);

        }



        Gtm.setStore(this);
        Gtm.push({
            event: "konfigurator_click",
            ecommerce: {
                button_name: step.name.toLowerCase(),
                button_typ: "szczegol",
                option: step.selectedOption?.name ?? o.selectedOption?.name ?? '',
                etap: step.stepNumber ?? 1,
                value: this.cart.totalPrice,
                items: [
                    {
                        item_name: this.product.name,
                        item_id: Gtm.getProductId(),
                        item_brand: "MyBed",
                        item_category: "Łóżka",
                        item_variant: Gtm.getVariantStr(),
                    }
                ]
            }
        });
        Clarity.push(`konfigurator_click - szczegol - ${step.name.toLowerCase()}`);

        console.groupEnd();
    }

    @action onDrawerFillChanged({prevStepValue, stepValue}){
        console.groupCollapsed('onDrawerFillChanged');
        console.log({prevStepValue, stepValue});
        // const step = this.getStepByOptionId(OPTION_DRAWER_FILL);
        const step = this.getStepByType('select_drawer_fill');
        const hasAddComponents = step.selectedOption?.hasAddComponents;
        if(hasAddComponents){
            console.log('hasAddComponents');
            this.addExtraSteps({owner: step, steps: step.selectedOption.add_components});
        }
        console.groupEnd();

        this.removeInvalidChildren();
    }

    @action onDimensionChanged({prevStepValue, stepValue}){
        console.groupCollapsed('onDimensionChanged');
        console.log({prevStepValue, stepValue});
        // if has dont have mattressHalfSize but mattressAmount == 2 change to 1
        // if(!this.hasSelectedMattressMatchingHalfSize && this.mattressAmount === 2){
        if(this.mattressHalfSize.length === 0 && this.mattressAmount === 2){
            this.setMattressAmount(1);
            console.warn('Cannot use half size mattress due to cannot_be_half flag');
            console.log(' -> reset mattress');

        }
        console.groupEnd();
    }

    @action removeInvalidChildren() {
        console.groupCollapsed('removeInvalidChildren');
        this.sortedStepsFlat.forEach((s) => {
            // if don't have add components or is not selected
            if(s.owner && (!s.owner.selectedOption || !s.owner.selectedOption.hasAddComponents)) {
                console.log(`Removing ${s.name} from store by owner ${s.owner.name}`);
                s.reset();
                this.steps.delete(s.id)
                // const ids = s.owner.selectedOption.add_components.map((c) => c.id);
                // ids.forEach((id) => {
                //     const step = this.steps.get(id);
                //     if(step){
                //         console.log(`Removing ${step.name} from store by owner ${s.owner.name}`);
                //         this.steps.delete(id)
                //     }
                // });
            }
        })
        console.groupEnd();
    }

    /**
     * 
     * @param {{owner:StepModel}} param0 
     */
    @action addExtraSteps({owner, steps}){
        console.groupCollapsed('addExtraSteps');
        console.log({owner, steps});
        steps.forEach((step) => {
            this.addExtraStep({step, owner});
        });
        console.groupEnd();
    }
    /**
     * 
     * @param {{owner:StepModel}} param0 
     */
    @action addExtraStep({step, owner}){
        console.groupCollapsed('addExtraStep ' + step.name);
        console.log({step, owner});
        let options = [];
        // if(step.id === OPTION_ADDITIONAL_MATTRESS){
        if(step?.attributes?.type === 'additional_mattress'){
            options = this.mattress;
        }

        this.steps.set(
            step.id,
            new StepModel({
                owner: owner,
                store: this,
                id: step.id,
                type: 'additional_mattress',
                group_id: null,
                name: step.name,
                required: false,
                stock: step.stock,
                options: options,
                // value:  options[0]?.valueId ?? null,
                value: null,
                done: false,
                active: false,
                order: parseInt(step.order) + 900,
                stepGroup: null,
                extra: true
            })
        );


        console.groupEnd();
    }

    @action onFrameChanged({prevStepValue, stepValue}){
        console.groupCollapsed('onFrameChanged');
        console.log({prevStepValue, stepValue});
        // const selectedMattress = this.getStepByType('mattress')?.selectedOption;
        if(!this.canUseFullSizeMattress && store.mattressAmount === 1){
            this.selectMattress({valueId: 0});
            this.setMattressAmount(2);
            console.warn('Cannot use full size mattress due to cannot_be_full flag');
            console.log(' -> reset mattress')
        }
        console.groupEnd();
    }

    @computed get invalidSteps() {
        return this.sortedStepsFlat.filter((step) => step.isValid === false);
    }
    @action scrollToFirstError(){
        const firstError = this.sortedStepsFlat.find((step) => step.isValid === false);
        console.log('scrollToFirstError', {firstError});
        if(firstError){
            store.scrollTo(firstError.typeId);
        }
    }

    @computed get isConfigurationCompleted() {
        // return false if not all required options are selected
        if (this.invalidSteps.length > 0) {
            return false;
        }

        if (this.invalidSteps.length > 0) {
            return this.extraProdcuts.every(
                (product) => product.areRequiredOptionsSelected
            );
        }
        return true;
    }

    getOptionsByOptionId(option_id) {
        const step = this.getStepByOptionId(option_id);
        if (step?.options) {
            return step.options;
        }

        return [];
    }


    @action setStepValue(stepId, value, {tracking = true} = {}) {
        this.updateOption(stepId, value, {tracking});
    }
    @action addExtraProduct({id, productsOptions = [], type, value} = {}) {
        if(!type){
            return;
        }
        const step = this.getStepByType(type);
        switch (type) {
            case "mattress":
                // `productsOptions` is empty for a configuration saved without a
                // mattress. Forcing the amount to 0 would make a later mattress
                // selection impossible (selectMattress slices selectedMattress to
                // the amount), so fall back to the single-mattress default.
                this.mattressAmount = productsOptions.length || 1;
                this.setStepValue(step.id, value, {tracking: false});
                this.selectMattress({valueId: value});
                this.selectedMattress.forEach((m, i) => {
                    var o = productsOptions.at(i);
                    if(o){
                        m.setOptions(o.options);
                    }
                })
                break;
            case "mattress_toppers":
                this.setStepValue(step.id, value, {tracking: false});
                this.selectTopMattress({valueId: value});
                this.selectedTopMattress.forEach((m, i) => {
                    var o = productsOptions.at(i);
                    if(o){
                        m.setOptions(o.options);
                    }
                })

            break;
            case "select_safety_type":
                this.setStepValue(step.id, value, {tracking: false});
                if (Array.isArray(value)) {
                    this.selectedSafetyProductIds = [...value];
                    this.selectedSafetyProducts = value
                        .map(v => this.safety_products.find(p => p.valueId === v))
                        .filter(Boolean);
                    this.selectedSafetyProducts.forEach((p) => {
                        const optEntry = productsOptions.find(o => o.id === p.id);
                        if (optEntry) p.setOptions(optEntry.options);
                    });
                } else {
                    const product = value ? this.safety_products.find(p => p.valueId === value) : null;
                    if (product) {
                        this.selectedSafetyProductIds = [value];
                        this.selectedSafetyProducts = [product];
                        if (productsOptions.length > 0) product.setOptions(productsOptions[0]?.options || {});
                    }
                }
                break;
        }
    }

    @action onResize = throttle((e) => {
        const renderTopOffset =
            document.querySelector(".SketchfabRender")?.getBoundingClientRect()
                ?.top || 0;
        window.document.documentElement.style = `--scroll-y: ${window.scrollY}px; --height-y: ${window.innerHeight}px; --render-top-offset: ${renderTopOffset}px;`;

        this.isAccordionOpenByDefault = window.innerWidth > BREAKPOINT_XL;
        this.isAccordionInteractive = window.innerWidth < BREAKPOINT_XL;
        this.isMobileDevice = isMobileDevice();
    }, 20);
    @action onScroll = throttle((e) => {
        const renderTopOffset =
            document.querySelector(".SketchfabRender")?.getBoundingClientRect()
                ?.top || 0;
        window.document.documentElement.style = `--scroll-y: ${window.scrollY}px; --height-y: ${window.innerHeight}px; --render-top-offset: ${renderTopOffset}px;`;
    }, 20);
}

const store = new StoreClass();
window['store'] = store;
export {
    store,
    StoreClass
};
